module.exports = __webpack_public_path__ + "static/egyptian-bedding-set-dusty-rose-2-316568d607644315d72d6cb48233667e.webp";